export enum MODULE_ID {
  WASTE = '3b986a73-9a6b-4477-8bdf-08c7502790e9',
  DELIVERY = '94d91d52-11d3-454b-85f1-e1dc79db23b0'
}
